import React from 'react';
import { RummyWheel } from './components/RummyWheel';
export function App() {
  return <main className="w-full min-h-screen" data-id="element-0">
      <RummyWheel data-id="element-1" />
    </main>;
}